<ng-container *ngIf="isLoading; else skillsList">
  <!-- don't show loading for search-layout-redesign -->
  <div *ngIf="!showSearchLayoutRedesign" class="l_flexbar guts-m-t-2">
    <div
      *ngFor="let _ of [].constructor(4); last as last"
      [ngClass]="{ 'guts-m-r-3': !last }"
      style="width: 12rem"
      data-dgat="search-related-skills-814"
    >
      <dgx-skeleton type="list" [rows]="1"></dgx-skeleton>
    </div>
  </div>
</ng-container>

<ng-template #skillsList>
  <div *ngIf="showSearchLayoutRedesign && hasRelatedSkills" class="guts-m-b-1">
    <ul class="related-skills l_flex m-l_flex l_flex-middle">
      <li
        *ngFor="
          let item of skills;
          index as $index;
          last as last;
          trackBy: trackByFn
        "
        [ngClass]="{ 'guts-m-r-half': !last }"
        class="guts-p-b-1-quart"
        data-dgat="search-related-skills-e9c"
      >
        <span
          class="related-skill border l_flexbar no-wrap"
          [ngbTooltip]="getTooltip(item.term)"
          [attr.aria-label]="getTooltip(item.term)"
        >
          <df-icon
            size="small"
            icon="magnifying-glass"
            class="related-skill__icon guts-m-r-half"
            role="presentation"
          ></df-icon>
          <a
            class="related-skill__link block font-semibold"
            (click)="handleClick(item.term, $index)"
            [routerLink]="['/learning/search']"
            [queryParams]="{ term: item.term }"
            data-dgat="search-related-skills-6af"
            >{{ item.term }}</a
          >
        </span>
      </li>
    </ul>
  </div>

  <div
    class="guts-p-full-1 bg-color-ebony-a03 guts-m-t-2"
    *ngIf="!showSearchLayoutRedesign && hasRelatedSkills"
  >
    <ul class="l_flex m-l_flex l_flex-wrap l_flex-middle rel m-no-guts">
      <li class="guts-p-h-1-half guts-p-v-half">
        <h4
          class="h4 up-me"
          [textContent]="i18n.LearningSearch_SuggestedSearches"
        ></h4>
      </li>

      <li
        *ngFor="
          let item of skills;
          index as $index;
          last as last;
          trackBy: trackByFn
        "
        [ngClass]="{ 'guts-m-r-3': !last }"
        data-dgat="search-related-skills-e9c"
      >
        <a
          class="block guts-p-h-1-half guts-p-v-half link font-semibold"
          (click)="handleClick(item.term, $index)"
          [routerLink]="['/learning/search']"
          [queryParams]="{ term: item.term }"
          data-dgat="search-related-skills-6af"
          >{{ item.term }}</a
        >
      </li>
    </ul>
  </div>
</ng-template>
